import React, { useState, useEffect, Children } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import moment from "moment";
import AuthAction from '../../../redux/auth/actions';
import CardLayout from '../../../components/utils/CardLayout'
import Button from '../../../components/utils/Button';
import InfiniteScroll from 'react-infinite-scroll-component';
import { EMAIL_PATTERN } from '../../../helpers/constant';
import OutsideEmailInboxAction from '../../../redux/outsideEmailInbox/actions';

const { getOutsideEmail, readOutsideMail, closeOutsideEMailTemplate } = OutsideEmailInboxAction
const { getUserDataByToken } = AuthAction;

function EmailInbox() {
    const dispatch = useDispatch();
    const [seachDone, setSeachDone] = useState(false);
    const [openEmailId, setOpenEmailId] = useState('');
    const [searchEmail, setsearchEmail] = useState('');
    const [showNoDataImage, setShowNoDataImage] = useState(false);
    const { getOutsideEMailResult, getOutsideEMailLoading, showNoDataFlag } = useSelector((state) => state.outsideEmailInbox);
    const [searchData, setSearchData] = useState({
        email: '',
    });
    const { register, handleSubmit, formState: { errors }, watch, reset: resetForm, control, setValue, } = useForm({
        defaultValues: searchData,
    });

    const [items, setItems] = useState(20);
    const [hasMore, setHasMore] = useState(true);
    const emailValue = watch("email");

    const fetchMoreData = () => {
        setTimeout(() => {
            if (items >= getOutsideEMailResult.length) {
                setHasMore(false);
                return;
            }
            setItems(items + 20);
        }, 1500);
    };

    useEffect(() => {
        if (!emailValue || emailValue.trim() === "") {
            setsearchEmail("");
            setSeachDone(false);
            setShowNoDataImage(false);
            setOpenEmailId("");
            setItems(20);
            setHasMore(true);
        }
    }, [emailValue]);


    useEffect(() => {
        dispatch(getUserDataByToken())
    }, [])

    const handleSearchData = (data) => {
        setSearchData(prevState => ({
            ...prevState,
        }))
        setsearchEmail(data.email)
        setSeachDone(true);
        dispatch(getOutsideEmail(data));
        setOpenEmailId('')
        setShowNoDataImage(true)
        setItems(20);
    }

    const handleOpenEmailTepmlate = (mailID) => {
        dispatch(readOutsideMail(mailID));
        setOpenEmailId(mailID)
        setShowNoDataImage(false)
    }

    const handleCloseEmaleTemp = (mailID) => {
        dispatch(closeOutsideEMailTemplate(mailID));
        setOpenEmailId('')
        setShowNoDataImage(false)
    }
    return (
        <>
            <CardLayout title="Outside E-Mail Inbox" cardClass='main-email-card'>
                <div className='search-email-box iq-card-body'>
                    <form onSubmit={handleSubmit(handleSearchData)}>
                        <div className="form-row mb-3">
                            <div className="col-lg-4">
                                <label>E-Mail/Mobile No.</label>
                                <input type="text" className="form-control" id="email" placeholder="E-Mail/Mobile No." {...register("email", {
                                    required: "E-Mail/Mobile No. is required !",
                                    // pattern: {
                                    //     value: EMAIL_PATTERN,
                                    //     message: "Email is not valid !"
                                    // }
                                })}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                            </div>
                            <div className='col-lg-6 mt-4 ml-0 pl-0'>
                                <div className="col-md-12" style={{ marginTop: '7px' }}>
                                    <Button title={'Search'} style="minWidth:80px" buttonClass="btn btn-primary" loading={getOutsideEMailLoading} buttonType='submit' />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                {searchEmail && getOutsideEMailResult ?
                    <div className='email-inbox-data'>
                        {<div>
                            <h4 className='email-search-msisdn'>{searchEmail}</h4>
                            <hr />
                        </div>}
                        {
                            showNoDataFlag && showNoDataImage && !getOutsideEMailLoading && seachDone && getOutsideEMailResult && getOutsideEMailResult.length === 0 ?
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12'>
                                        <p style={{ textAlign: 'center' }}>No data found</p>
                                    </div>
                                </div> : ''
                        }

                        {getOutsideEMailResult && getOutsideEMailResult.length > 0 &&
                            <div>
                                <InfiniteScroll
                                    dataLength={items}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={<div className='d-flex justify-content-center infinite-scroll-loader'><span className="spinner-border spinner-border-sm" role="status"></span></div>}
                                    endMessage={!openEmailId && <div className='d-flex justify-content-center mb-0 pt-2'><p>No more items!</p></div>}
                                >
                                    {
                                        getOutsideEMailResult && getOutsideEMailResult.length > 0 && getOutsideEMailResult.filter((data, ind) => ind <= items && openEmailId ? data.ID == openEmailId : data).map((item, index) => {
                                            let html = JSON.parse(item.ReceivedData).data.html;
                                            return <>

                                                {!item.showMail ? <div className='row' style={{ cursor: 'pointer' }} key={item.ID} onClick={() => handleOpenEmailTepmlate(item.ID)}>
                                                    <div className='col-lg-12 col-md-12' >
                                                        <div className={item.IsRead == 0 ? 'email-card-list read ' : 'email-card-list unread'}>
                                                            <div className='row'>
                                                                <div className='col-lg-3 col-md-3 email-name'><p >{item.ToEmail}</p></div>
                                                                <div className='col-lg-7 col-md-7 second-email text-start'><p>{item.EmailSubject}</p></div>
                                                                <div className='col-lg-2 col-md-2 third-email text-end' style={{ textAlign: 'end' }}><p >{moment(item.CreatedDtTm).tz(process.env.REACT_APP_TIMEZONE).format("MMM Do")}</p></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                    : <div className='row '>
                                                        <div className='col-lg-12 col-md-12'>
                                                            <div className='card-email-detail-card'>
                                                                <div className='wrong-icon'>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                        <div className='feb-arrow-icon' style={{ cursor: 'pointer' }} onClick={() => handleCloseEmaleTemp(item.ID)}>
                                                                            <i style={{ fontSize: '1.3rem' }} className="ri-arrow-left-line"></i>
                                                                        </div>
                                                                        <div>{item?.ToEmail}</div>
                                                                    </div>

                                                                    <div>{moment(item.CreatedDtTm).tz(process.env.REACT_APP_TIMEZONE).format('ddd, MMM D, YYYY, h:mm A')}</div>
                                                                </div>
                                                                <div className='details-inner-card'>
                                                                    <div dangerouslySetInnerHTML={{ __html: html }} />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>}
                                            </>
                                        })
                                    }

                                </InfiniteScroll>
                            </div>}
                    </div> : ''}
            </CardLayout>

        </>

    )
}

export default EmailInbox;
